import { connect } from 'react-redux'
import Finished from './finished'
import { redirectAfterAuth } from 'pobble-components/dist/auth-helpers'
import { withMe } from 'pobble-components/dist/pobble-user'
import { isRedirectAfterAuthTest } from '../../../../../common/redirect-after-auth-flag'

const mapDispatchToProps = () => ({
  onGoToPobble: () => redirectAfterAuth(isRedirectAfterAuthTest())
})

export default withMe(
  connect(
    null,
    mapDispatchToProps
  )(Finished)
)
